import { ImgHTMLAttributes } from "react";

export const PaytrieLogo = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src="/paytrie-logo.png" alt="Paytrie" {...props} />
);
